import { AbstractType } from "@angular/core";

export class VwCommissionPanelModel {
    public commissionId?:number;
    public businessProductId?:number;
    public businessProductDesc?:string;
    public ownerTypeId?:number;
    public ownerTypeDesc?:string;
    public financingTypeId?:number;
    public financingTypeDesc?:string;
    public afiliateId?:number;
    public afiliateDesc?:string;
    public paymentId?:number;
    public paymentDesc?:string;
    public employeeJobId?:number;
    public employeeJobDesc?:string;
    public schemaId?:number;
    public schemaDesc?:string;
    public productCategoryId?:number;
    public productCategoryDesc?:string;
    public promotionId?:string;
    public commission?:number;
    public userId?:number;
    public activeId?:boolean;
    public selected?:boolean = false;
    public createDate?:any;
    public createUser?:any;
    public modifiDate?:any;
    public modifiUser?:any;
}